module.exports = __webpack_public_path__ + "static/img/6.44f9cff.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/3/6/sp/6.png
// module id = sI+1
// module chunks = 0